/**
 * @generated SignedSource<<13ff59bdf3593036fcc8a2501497e129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromptRow_savedPrompt$data = {
  readonly id: string;
  readonly name: string | null;
  readonly promptText: string | null;
  readonly " $fragmentType": "PromptRow_savedPrompt";
};
export type PromptRow_savedPrompt$key = {
  readonly " $data"?: PromptRow_savedPrompt$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromptRow_savedPrompt">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromptRow_savedPrompt",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promptText",
      "storageKey": null
    }
  ],
  "type": "SavedPrompt",
  "abstractKey": null
};

(node as any).hash = "b436001c68ca78f3b58066a268d6d8e8";

export default node;
